import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3644610411/src/src/app/components/layout/ClientLayout.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3644610411/src/src/app/globals.css");
